import GDPRTools from './GDPRTools';
import './GDPRTools.scss';

export default GDPRTools;
